/* ============================================================================
   drb-achat-fiche.js — fiche produit « Devanture » (LOT 5, 04/10/2026, refonte validée par Benoit le 04/10).
   Chargé en defer par snippets/drb-b2b-buy.liquid (fiche produit seulement). Idempotent : garde __drbAchatFiche.
   Le premier rendu est entièrement fait en Liquid ; ce fichier ne fait que SUIVRE la quantité :
     1. sélecteur par carton (bloc d'achat + barre mobile) : quantité au pas du carton / de la règle de quantité,
        jamais sous le minimum ; champ « quantity » du formulaire produit Dawn mis à jour (l'ajout reste celui de
        product-form.js : erreurs Shopify, tiroir, offre chambres + thermomètres de drb-portal.js inchangés) ;
     2. palier atteint (ligne menthe), prix du palier, prix du carton, total HT et unités dans le bouton,
        « Encore N cartons pour passer à X € HT » ;
     3. date de livraison : AUCUNE règle ici. Elle vient du moteur commun assets/drb-transport.js
        (DrbTransport.livraison(enPalette) : date d'expédition et de livraison, jours ouvrés, jours fériés), chargé
        une seule fois (repris du tiroir s'il est déjà là). Format validé : « Livré mardi 6 octobre si commandé avant
        lundi 12 h » ; colis ou palette selon DrbTransport.plan (plus de 6 colis = palette) ;
     4. progression vers le franco : panier + sélection, règle de snippets/drb-franco-regle.liquid (250 € HT ;
        100 € HT si un produit franco-100, cumul hors lignes hors-franco-100) ;
     5. barre d'achat mobile : au-dessus de la barre d'onglets (.drb-mbar) et du bouton WhatsApp, visible seulement
        quand le bouton du bloc d'achat est hors écran (un seul bouton primaire par écran) ;
     6. galerie : vignettes, points, agrandissement.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__drbAchatFiche) return;
  window.__drbAchatFiche = true;

  /* formats : mêmes règles que snippets/drb-prix3.liquid (3 décimales seulement si la 3e est significative) */
  function prix(v) { var m = Math.round(v * 1000); var s = (m % 10 === 0 ? (m / 1000).toFixed(2) : (m / 1000).toFixed(3)); return s.replace('.', ',') + ' €'; }
  function eur(v) { return v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, ' ') + ' €'; }
  function nb(x) { return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  function pl(n, s, p) { return n > 1 ? (p || s + 's') : s; }

  /* ---------- 3. date : moteur commun drb-transport.js (jamais recopié ici) ---------- */
  var JL = { weekday: 'long', day: 'numeric', month: 'long' };
  var trWait = null;
  function transport(src, heppner) {
    if (window.DrbTransport) return Promise.resolve(window.DrbTransport);
    if (trWait) return trWait;
    trWait = new Promise(function (ok) {
      var s = document.querySelector('script[src*="drb-transport"]');
      if (!s && src) { s = document.createElement('script'); s.src = src; s.defer = true; if (heppner) s.setAttribute('data-drb-heppner-url', heppner); document.head.appendChild(s); }
      if (!s) return ok(null);
      s.addEventListener('load', function () { ok(window.DrbTransport || null); });
      s.addEventListener('error', function () { ok(null); });
      setTimeout(function () { ok(window.DrbTransport || null); }, 8000);
    });
    return trWait;
  }
  function memeJour(a, b) { return a && b && a.toDateString() === b.toDateString(); }
  /* libellé court du moteur (« mer. 7 oct. ») -> format validé (« mercredi 7 octobre ») : simple réécriture des
     abréviations françaises de toLocaleDateString, aucun calcul de date */
  var JOURS = { 'lun.': 'lundi', 'mar.': 'mardi', 'mer.': 'mercredi', 'jeu.': 'jeudi', 'ven.': 'vendredi', 'sam.': 'samedi', 'dim.': 'dimanche' };
  var MOIS = { 'janv.': 'janvier', 'févr.': 'février', 'avr.': 'avril', 'juil.': 'juillet', 'sept.': 'septembre', 'oct.': 'octobre', 'nov.': 'novembre', 'déc.': 'décembre' };
  function longFr(t) { return String(t || '').split(/\s+/).map(function (w) { return JOURS[w] || MOIS[w] || w; }).join(' '); }
  /* ---------- colisage : moteur commun drb-transport.js s'il est chargé, sinon même règle recopiée ---------- */
  var LT = { regle_colis: 6, chrono_max: 30, colis_max_vol: 0.10, pal_vol: 1.2, pal_poids: 600, demi_vol: 0.5,
    densite: 200, densite_liq: 650, densite_brum: 500, densite_coton: 120, densite_sacs: 400 };
  function densite(ref, nom) {
    var r = (ref || '').toUpperCase(), n = (nom || '').toUpperCase();
    if (r.indexOf('BRUM') === 0) return LT.densite_brum;
    if (r.indexOf('CTN') === 0 || /COTON/.test(n)) return LT.densite_coton;
    if (/^(PHARMA_BAG|SAC|RL|LAF|GL_|GV_)/.test(r) || /\bSAC|ROULEAU|GANT/.test(n)) return LT.densite_sacs;
    if (/^(SPHY|ECOTNR|EAU|HLAMANDE|CHLORHEX|DCH|SPRAY|KIT_IRRIG)/.test(r) || (/\b\d+\s?(ML|L)\b/.test(n) && !/GOURDE|VENTILATEUR|POT/.test(n))) return LT.densite_liq;
    return LT.densite;
  }
  function pack(cartons, capW, capV) {
    var items = cartons.slice().sort(function (a, b) { return b.v - a.v; }), bins = [];
    items.forEach(function (c) {
      if (c.w > capW || c.v > capV) { var k = Math.max(Math.ceil(c.w / capW), Math.ceil(c.v / capV)); for (var i = 0; i < k; i++) bins.push({ w: c.w / k, v: c.v / k, split: true }); return; }
      var b = null; for (var j = 0; j < bins.length; j++) { if (!bins[j].split && bins[j].w + c.w <= capW && bins[j].v + c.v <= capV) { b = bins[j]; break; } }
      if (!b) { b = { w: 0, v: 0 }; bins.push(b); }
      b.w += c.w; b.v += c.v;
    });
    return bins;
  }
  function colisage(q, pcb, kg, vol, ref, nom) {
    if (window.DrbTransport && window.DrbTransport.plan) {
      try { var T = window.DrbTransport.plan([{ q: q, pcb: pcb, kg: kg, vol: vol, ref: ref, t: nom }], null);
        return { colis: T.colis, poids: T.poids, enPalette: T.enPalette, pal: T.PL ? T.PL.pal : 0, demi: T.PL ? T.PL.demi : 0 }; } catch (e) {}
    }
    var volU = vol || (kg / densite(ref, nom)), cartons = [], rest = q;
    while (rest > 0) { var n = Math.min(pcb, rest); cartons.push({ w: n * kg, v: n * volU }); rest -= n; }
    var CH = pack(cartons, LT.chrono_max, LT.colis_max_vol), enPal = CH.length > LT.regle_colis, pal = 0, demi = 0;
    if (enPal) { pack(cartons, LT.pal_poids, LT.pal_vol).forEach(function (b) { if (b.v <= LT.demi_vol && b.w <= LT.pal_poids / 2) demi++; else pal++; }); }
    return { colis: CH.length, poids: q * kg, enPalette: enPal, pal: pal, demi: demi };
  }
  function palLabel(c) { var a = []; if (c.pal) a.push(c.pal + ' ' + pl(c.pal, 'palette')); if (c.demi) a.push(c.demi + ' ' + pl(c.demi, 'demi-palette')); return a.join(' + ') || 'palette'; }

  /* ---------- composant ---------- */
  class DrbAchat extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      var D = this.dataset;
      this.pcb = Math.max(1, +D.pcb || 1);
      this.uc = +D.uc || 0;
      this.step = Math.max(1, +D.step || this.pcb);
      this.min = Math.max(this.step, +D.min || this.step);
      this.max = +D.max || 0;
      this.kg = parseFloat(D.kg) || 0;
      this.vol = parseFloat(D.vol) || 0;
      this.carton = this.pcb > 1 || this.uc > 0;
      this.cut = parseInt(D.cutoff, 10); if (isNaN(this.cut)) this.cut = 12;
      this.pid = +D.pid || 0;
      this.fr100 = D.fr100 === 'true'; this.hors = D.hors === 'true'; this.fr150 = D.fr150 === 'true'; /* franco-150-panier-2026-10-06 */ this.fr300 = D.fr300 === 'true'; /* francos-multiples-2026-10-07 */
      this.cart = { net: (+D.cartNet || 0) / 100, base: (+D.cartBase || 0) / 100, covid: D.cartCovid === 'true', cul: D.cartCul === 'true', lourd: D.cartLourd === 'true' };
      try { this.tiers = JSON.parse(this.querySelector('[data-a-tiers]').textContent).filter(function (t) { return t && t.q > 0 && t.pv > 0; }).sort(function (a, b) { return a.q - b.q; }); } catch (e) { this.tiers = []; }
      this.$q = this.querySelector('[data-a-q]');
      this.q = this.norm(this.$q ? parseInt(this.$q.value, 10) : this.min);

      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-a-step]');
        if (b) { e.preventDefault(); if (!b.disabled) self.set(self.q + (+b.getAttribute('data-a-step')) * self.step); return; }
        var tr = e.target.closest('tr[data-q]');
        if (tr) self.set(+tr.getAttribute('data-q'));
      });
      this.addEventListener('keydown', function (e) {
        var tr = e.target.closest && e.target.closest('tr[data-q]');
        if (tr && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); self.set(+tr.getAttribute('data-q')); }
      });
      this.querySelectorAll('[data-a-n]').forEach(function (inp) {
        inp.addEventListener('change', function () { var n = parseInt(inp.value, 10); self.set(isNaN(n) ? self.min : n * self.pcb); });
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } });
      });
      this.render();
      this.watchAdd();
      transport(D.transport, D.heppner).then(function (TR) { self.TR = TR; self.renderLivr(); });
      this.initSbar();
      this.watchCart();
    }

    /* product-form.js reste silencieux si Shopify répond autre chose que du JSON (429 « réessayez », coupure) :
       on affiche alors le même message que drb-portal.js (cartAdd), dans la zone d'erreur du formulaire */
    watchAdd() {
      var form = this.querySelector('form[data-type="add-to-cart-form"]'), btn = this.querySelector('.product-form__submit'),
          wrap = this.querySelector('.product-form__error-message-wrapper'), pending = false;
      if (!form || !btn || !wrap) return;
      var MSG = "Le panier n'a pas répondu. Réessayez dans un instant ; si cela persiste, appelez-nous au 01 80 88 37 40 ou commandez par e-mail à commandes@docteurb.fr.";
      form.addEventListener('submit', function () { pending = true; }, true);
      try { if (window.subscribe && window.PUB_SUB_EVENTS) { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { pending = false; }); window.subscribe(window.PUB_SUB_EVENTS.cartError, function () { pending = false; }); } } catch (e) {}
      new MutationObserver(function () {
        if (btn.classList.contains('loading') || !pending) return;
        setTimeout(function () {
          if (pending && wrap.hidden) { var m = wrap.querySelector('.product-form__error-message'); if (m) m.textContent = MSG; wrap.hidden = false; }
          pending = false;
        }, 300);
      }).observe(btn, { attributes: true, attributeFilter: ['class'] });
    }

    norm(q) {
      q = Math.ceil((parseInt(q, 10) || this.min) / this.step) * this.step;
      if (q < this.min) q = this.min;
      if (this.max && q > this.max) q = Math.max(this.min, Math.floor(this.max / this.step) * this.step);
      return q;
    }
    set(q) { this.q = this.norm(q); this.render(); }
    tierIdx(q) { var k = 0; for (var i = 0; i < this.tiers.length; i++) if (this.tiers[i].q <= q) k = i; return k; }

    render() {
      var q = this.q, pcb = this.pcb, uc = this.uc, T = this.tiers;
      if (this.$q) this.$q.value = q;
      var idx = this.tierIdx(q), pv = T.length ? T[idx].pv : 0, pv0 = T.length ? T[0].pv : 0, tot = q * pv;
      var n = Math.round(q / pcb), lbl = this.carton ? 'carton' : 'unité';
      var small = uc > 0 ? nb(q * uc) + ' pièces' : (pcb > 1 ? nb(q) + ' unités' : '');
      /* sélecteurs */
      this.querySelectorAll('[data-a-n]').forEach(function (i) { if (document.activeElement !== i) i.value = n; i.style.width = (String(n).length + 0.6) + 'ch'; });
      var nl = this.querySelector('[data-a-nl]'); if (nl) nl.textContent = pl(n, lbl);
      var u = this.querySelector('[data-a-u]'); if (u) u.textContent = small;
      var sn = this.querySelector('[data-a-sn]');
      if (sn) sn.innerHTML = nb(n) + ' ' + (this.carton ? 'crt' : 'u.') + (small ? '<small>' + (uc > 0 ? small : nb(q) + ' u.') + '</small>' : '');
      var minOff = q <= this.min, maxOff = !!(this.max && q + this.step > this.max);
      this.querySelectorAll('[data-a-step="-1"]').forEach(function (b) { b.disabled = minOff; });
      this.querySelectorAll('[data-a-step="1"]').forEach(function (b) { b.disabled = maxOff; });
      /* prix du palier, prix barré, carton */
      var pu = this.querySelector('[data-a-pu]'); if (pu) pu.textContent = uc > 0 ? eur(pv) : prix(pv);
      var bs = this.querySelector('[data-a-base]'); if (bs) bs.hidden = !(pv < pv0 - 0.0005);
      var pc = this.querySelector('[data-a-pc]');
      if (pc) pc.textContent = uc > 0 ? '· soit ' + prix(pv / uc) + ' HT la pièce' : '· ' + eur(pv * pcb) + ' HT le carton';
      /* tableau */
      this.querySelectorAll('tr[data-q]').forEach(function (tr, i) { tr.classList.toggle('on', i === idx); tr.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      /* boutons */
      var bt = this.querySelector('[data-a-btn]'); if (bt) bt.textContent = eur(tot) + ' HT · ' + (small || nb(q) + ' ' + pl(q, 'unité'));
      var sb = this.querySelector('[data-a-sbtn-s]'); if (sb) sb.textContent = eur(tot) + ' HT · ' + (uc > 0 ? eur(pv) + ' le carton' : prix(pv) + ' l’unité');
      /* palier suivant */
      var nd = this.querySelector('[data-a-nudge-t]');
      if (nd && T.length > 1) {
        var t = T[idx + 1], unit = uc > 0 ? 'le carton' : 'l’unité';
        if (t) {
          var qn = Math.ceil(t.q / this.step) * this.step, need = Math.max(1, Math.round((qn - q) / pcb));
          var pct = Math.round((1 - t.pv / pv0) * 100);
          nd.innerHTML = 'Encore <b>' + nb(need) + ' ' + pl(need, lbl) + '</b> pour passer à <b>' + prix(t.pv) + ' HT</b> ' + unit + (pct > 0 ? ' (−' + pct + ' %).' : '.');
        } else nd.innerHTML = 'Meilleur prix atteint : <b>' + prix(pv) + ' HT</b> ' + unit + '.';
      }
      this.renderFranco(tot);
      this.renderLivr();
    }

    /* ---------- 4. franco : même règle que snippets/drb-franco-regle.liquid ---------- */
    renderFranco(sel) {
      var box = this.querySelector('[data-a-franco]'); if (!box) return;
      var c = this.cart, net = c.net + sel, base = c.base + (this.hors ? 0 : sel), covid = c.covid || this.fr100, cul = c.cul || this.fr150;
      var lourd = c.lourd || this.fr300;   /* francos-multiples-2026-10-07 : sérum ou sacs → 300 € sur toute la commande */
      if (net >= 250 || lourd) covid = false;
      if (covid || net >= 250 || lourd) cul = false;
      var seuil = lourd ? 300 : (covid ? 100 : (cul ? 150 : 250)), cumul = (covid || cul) ? base : net, manque = Math.max(0, seuil - cumul);
      var lib = 'franco ' + (lourd ? 'sérum et sacs ' : (covid ? 'COVID ' : (cul ? 'culottes et bonbons ' : ''))) + seuil + ' € HT';
      var t = box.querySelector('[data-a-franco-t]');
      if (t) t.innerHTML = manque <= 0.004 ? 'Livraison offerte : ' + lib + ' atteint.' : 'Plus que <b>' + eur(manque) + ' HT</b> pour la livraison offerte (' + lib + ')';
      box.classList.toggle('is-ok', manque <= 0.004);
      var bar = box.querySelector('[data-a-franco-bar]'); if (bar) bar.style.width = Math.min(100, cumul / seuil * 100).toFixed(1) + '%';
      var pb = box.querySelector('[role=progressbar]'); if (pb) { pb.setAttribute('aria-valuemax', seuil); pb.setAttribute('aria-valuenow', Math.min(seuil, Math.round(cumul))); }
    }
    watchCart() {
      var self = this, tm = null;
      function maj() {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var F = window.__drbFr || { c: [], x: [], u: [] }, net = 0, base = 0, covid = false, cul = false, lourd = false;
          (c.items || []).forEach(function (i) { var e = i.final_line_price / 100; net += e; if (F.c.indexOf(i.product_id) > -1) covid = true; if ((F.u || []).indexOf(i.product_id) > -1) cul = true; if ((F.l || []).indexOf(i.product_id) > -1) lourd = true; if (F.x.indexOf(i.product_id) === -1) base += e; });
          self.cart = { net: net, base: base, covid: covid, cul: cul, lourd: lourd };
          self.renderFranco(self.q * (self.tiers.length ? self.tiers[self.tierIdx(self.q)].pv : 0));
        }).catch(function () {});
      }
      function plus_tard() { clearTimeout(tm); tm = setTimeout(maj, 350); }
      try { if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, plus_tard); } catch (e) {}
      document.querySelectorAll('[data-drb-cartpill]').forEach(function (p) { new MutationObserver(plus_tard).observe(p, { childList: true, characterData: true, subtree: true }); });
    }

    /* ---------- 3. livraison : DrbTransport.livraison() (règle commune, jours fériés compris) ---------- */
    renderLivr() {
      var b = this.querySelector('[data-a-date]'), p = this.querySelector('[data-a-dnote]'), TR = this.TR || window.DrbTransport;
      var boxD = this.querySelector('[data-a-dispo]');   /* produit livrable à partir d'une date (métachamp drb.dispo_le, 05/10/2026) : le texte Liquid reste */
      if (boxD && b && p) { b.textContent = 'Livraison à partir du ' + boxD.getAttribute('data-a-dispo'); p.textContent = 'commandez dès maintenant · livraison Chronopost à partir de cette date'; return; }
      if (!b || !p || !TR || !TR.livraison) return;   /* sans moteur : le texte neutre du Liquid reste */
      var c = colisage(this.q, this.pcb, this.kg, this.vol, this.dataset.ref, this.dataset.nom), L;
      try { L = TR.livraison(!!c.enPalette); } catch (e) { return; }
      if (!L) return;
      var exp = L.exp instanceof Date ? L.exp : null;
      var quand = '';   /* 07/10/2026 : plus d'heure limite ni de délai */
      var kg = c.poids > 0 ? (Math.round(c.poids * 10) / 10).toLocaleString('fr-FR') + ' kg' : '';
      var d = L.d || L.date || L.livraison, d1 = L.d1 || L.min, d2 = L.d2 || L.max;   /* dates si le moteur les expose, sinon son libellé */
      if (!c.enPalette) {
        b.textContent = 'Livraison Chronopost';
        p.textContent = this.kg > 0 ? c.colis + ' colis · ' + kg + ' · suivi en ligne' : 'colis suivi en ligne';
      } else {
        b.textContent = 'Livraison sur palette';
        p.textContent = (quand ? quand + ' · ' : '') + 'messagerie, ' + palLabel(c) + (kg ? ' · ' + kg : '');
      }
    }

    /* ---------- 5. barre d'achat mobile ---------- */
    initSbar() {
      var bar = this.querySelector('[data-a-sbar]'); if (!bar) return;
      var self = this, mq = window.matchMedia('(max-width: 749px)'), main = this.querySelector('.dv-qty'), vu = true;
      document.body.appendChild(bar); /* hors de la colonne collante : position fixe fiable */
      this.$sbar = bar;
      function place() {
        var mb = document.querySelector('.drb-mbar'), h = 0;
        if (mb && getComputedStyle(mb).display !== 'none') h = Math.round(mb.getBoundingClientRect().height);
        bar.style.setProperty('--dv-sbar-bas', h + 'px');
        document.body.classList.toggle('dv-sbar-on', mq.matches);
        document.documentElement.style.setProperty('--dv-sbar-h', Math.round(bar.getBoundingClientRect().height || 72) + 'px');
      }
      function show() { var on = mq.matches && (!vu || !main || getComputedStyle(main).display === 'none'); bar.hidden = false; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bar.inert = !on; }
      if ('IntersectionObserver' in window && main) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { vu = e.isIntersecting; }); show(); }, { rootMargin: '0px 0px -40px 0px' }).observe(main);
      } else { vu = false; }
      place(); show();
      window.addEventListener('resize', function () { place(); show(); });
      new MutationObserver(function () { place(); }).observe(document.body, { childList: true });
      /* état du bouton principal (chargement) et erreurs Shopify recopiés sur la barre */
      var btn = this.querySelector('.product-form__submit'), sbtn = bar.querySelector('[data-a-sbtn]'), err = this.querySelector('.product-form__error-message-wrapper'), serr = bar.querySelector('[data-a-sbar-err]');
      if (btn && sbtn) new MutationObserver(function () { sbtn.classList.toggle('loading', btn.classList.contains('loading')); sbtn.setAttribute('aria-disabled', btn.getAttribute('aria-disabled') === 'true' ? 'true' : 'false'); }).observe(btn, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
      if (err && serr) new MutationObserver(function () { var m = err.querySelector('.product-form__error-message'); serr.hidden = err.hidden; serr.textContent = m ? m.textContent : ''; place(); }).observe(err, { attributes: true, childList: true, subtree: true, characterData: true });
      /* la barre est sortie du composant : ses clics repassent par lui */
      bar.addEventListener('click', function (e) { var b = e.target.closest('[data-a-step]'); if (b && !b.disabled) { e.preventDefault(); self.set(self.q + (+b.getAttribute('data-a-step')) * self.step); } });
      var r0 = this.render.bind(this);
      this.render = function () { r0(); self.renderSbar(); };
      this.renderSbar();
    }
    renderSbar() {
      var bar = this.$sbar; if (!bar) return;
      var q = this.q, pcb = this.pcb, uc = this.uc, n = Math.round(q / pcb), T = this.tiers, pv = T.length ? T[this.tierIdx(q)].pv : 0;
      var small = uc > 0 ? nb(q * uc) + ' pièces' : (pcb > 1 ? nb(q) + ' u.' : '');
      var sn = bar.querySelector('[data-a-sn]'); if (sn) sn.innerHTML = nb(n) + ' ' + (this.carton ? 'crt' : 'u.') + (small ? '<small>' + small + '</small>' : '');
      var sb = bar.querySelector('[data-a-sbtn-s]'); if (sb) sb.textContent = eur(q * pv) + ' HT · ' + (uc > 0 ? eur(pv) + ' le carton' : prix(pv) + ' l’unité');
      bar.querySelectorAll('[data-a-step="-1"]').forEach(function (b) { b.disabled = q <= this.min; }, this);
      bar.querySelectorAll('[data-a-step="1"]').forEach(function (b) { b.disabled = !!(this.max && q + this.step > this.max); }, this);
    }
  }
  if (!customElements.get('drb-achat')) customElements.define('drb-achat', DrbAchat);

  /* ---------- 6. galerie ---------- */
  function initGal(g) {
    if (g._ok) return; g._ok = true;
    var track = g.querySelector('[data-dv-gal-track]'), ths = g.querySelectorAll('[data-dv-gal-th]'), dots = g.querySelectorAll('.dv-gal__dots i');
    var slides = g.querySelectorAll('[data-dv-gal-slide]');
    function mark(i) {
      ths.forEach(function (t, k) { t.classList.toggle('on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    ths.forEach(function (t) { t.addEventListener('click', function () { var i = +t.getAttribute('data-dv-gal-th'); if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); mark(i); }); });
    if (track && slides.length > 1) {
      var tm; track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60); }, { passive: true });
    }
    var dlg = g.querySelector('[data-dv-zoom]'), img = g.querySelector('[data-dv-zoom-img]');
    g.addEventListener('click', function (e) {
      var z = e.target.closest('[data-dv-gal-zoom]'); if (!z || !dlg || !img || typeof dlg.showModal !== 'function') return;
      img.src = z.getAttribute('data-dv-gal-zoom'); dlg.showModal();
    });
    if (dlg) dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }
  function init() { document.querySelectorAll('[data-dv-gal]').forEach(initGal); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
